import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
    selector: 'app-dialog-warning-delete',
    templateUrl: './dialog-warning-delete.component.html',
    styleUrls: ['./dialog-warning-delete.component.scss'],
    standalone: false
})
export class DialogWarningDeleteComponent implements OnInit {
	@Output() passEntry: EventEmitter<any> = new EventEmitter();
	@Input() loading: boolean;
	@Input() msgVald: number;
	@Input() mainTitle: string;
	@Input() customBodyMessage: string;
	/** Si se define, reemplaza el título "Eliminación de {{ mainTitle }}" (p. ej. seguimiento PJUD). */
	@Input() headerTitleOverride: string;
	@Input() primaryButtonClass = 'btn-danger';
	@Input() loadingButtonText = 'Eliminando...';
	@Input() confirmButtonText = 'Ok';

	errorMessage: string = '';
	public _success = new Subject<string>();
	private _error = new Subject<string>();
	successMessage = '';
	constructor(
		public activeModal: NgbActiveModal,
	) { }
  ngOnInit() {
		this.messageValidation();
	}
	ngOnChanges(changes: SimpleChanges): void {
		if (this.msgVald === 1) {
			this._success.next('Eliminación efectuada.');
		} else if (this.msgVald === 0) {
			this._error.next('Error: No se pudo eliminar lo requerido.');
		}
	}
	closeModal() {
		this.activeModal.close('Modal Closed');
	}
	confirmDelete() {
		this.passEntry.emit(true);
	}
	messageValidation() {
		this._success.subscribe(message => this.successMessage = message);
		this._success.pipe (
			debounceTime(2000)
		).subscribe(() => this.successMessage = '');
		this._error.subscribe(message => this.errorMessage = message);
		this._error.pipe (
				debounceTime(2000)
		).subscribe(() => this.errorMessage = '');
	}
}
